// extracted by mini-css-extract-plugin
export default {"view-switch":"ViewSwitch_view-switch__uFwCp","view-switch-btn":"ViewSwitch_view-switch-btn__vYCe1","view-switch-btn-active":"ViewSwitch_view-switch-btn-active__ecsJh"};